import { lazy } from 'react';
/** Открывает карточку промокода */
export const PromoCodeDetailsPageAsync = lazy(() => import('./PromoCodeDetails/PromoCodeDetailsPage'));